// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__8TsNV","vLegacy":"SelectSecondary_vLegacy__1o7Sd","error":"SelectSecondary_error__11yf8","disabled":"SelectSecondary_disabled__2CCdE"};